import React, { memo } from "react";
import { Position } from "@xyflow/react";
import NodeWrapper from "./NodeWrapper";
import { CallSplit } from "@mui/icons-material";

const OPERATORS = { 1: "==", 2: ">=", 3: "<=", 4: "<", 5: ">", 6: "!=" };

const ConditionNode = memo(({ id, data, isConnectable, selected }) => {
  const op = OPERATORS[data?.condition] || "?";
  const key = data?.key || "campo";
  const value = data?.value || "valor";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<CallSplit />}
      title="Condicao"
      color="#555"
      bgColor="#f5f5f5"
      isConnectable={isConnectable}
      selected={selected}
      minWidth={210}
      handles={[
        { id: "a", type: "source", position: Position.Right, style: { top: "65%" } },
        { id: "b", type: "source", position: Position.Right, style: { top: "88%" } },
      ]}
    >
      {/* Condition expression */}
      <div
        style={{
          background: "#fff",
          border: "1px solid #e0e0e0",
          borderRadius: 6,
          padding: "6px 10px",
          display: "flex",
          alignItems: "center",
          gap: 6,
          fontSize: 12,
          fontFamily: "'Fira Code', 'Consolas', monospace",
        }}
      >
        <span style={{ color: "#1565C0", fontWeight: 600 }}>{key}</span>
        <span
          style={{
            color: "#fff",
            background: "#555",
            borderRadius: 4,
            padding: "1px 6px",
            fontSize: 11,
            fontWeight: 700,
          }}
        >
          {op}
        </span>
        <span style={{ color: "#C62828", fontWeight: 600 }}>{value}</span>
      </div>

      {/* SIM / NAO labels (handles agora via prop handles do NodeWrapper) */}
      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 8 }}>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "flex-end",
          gap: 6, paddingRight: 4,
        }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#4caf50", borderRadius: 4,
            padding: "2px 10px", letterSpacing: "0.04em",
          }}>
            SIM
          </span>
        </div>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "flex-end",
          gap: 6, paddingRight: 4,
        }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#ef5350", borderRadius: 4,
            padding: "2px 10px", letterSpacing: "0.04em",
          }}>
            NAO
          </span>
        </div>
      </div>
    </NodeWrapper>
  );
});

ConditionNode.displayName = "ConditionNode";
export default ConditionNode;
